import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/tagging/vuex/index.js